import { MenuModel } from './models/MenuModel';
import { ConcessionariaModel } from './models/ConcessionariaModel';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ConfiguracaoConcessionariaProvider } from '../providers/configuracao-concessionaria/configuracao-concessionaria';
import { ConfigHelper } from './helpers/configHelper';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { SpinnerProvider } from '../providers/spinner/spinner';
import { FileTransfer } from "@ionic-native/file-transfer";
import { FileOpener } from "@ionic-native/file-opener";
import { File } from "@ionic-native/file";
import { AlertProvider } from '../providers/alert/alert';
import { SocketProvider } from '../providers/socket/socket';

//import { PushNotificationProvider } from '../providers/push-notification/push-notification';
// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  //rootPage: any = 'ConfiguracaoConcessionariaPage';
  rootPage: any;
  multiChecklists: boolean = false;
  checklistsNome: Array<any>;
  concessionaria: ConcessionariaModel = new ConcessionariaModel();
  myProjeto: string = "acampa_lust";
  pages: Array<MenuModel>;
  logoAtual: string = 'assets/imgs/logoacampa_top.png';

  link_politica_privacidade="https://sgsipoliticaprivacidade.blob.core.windows.net/acampapolicy/Politica_de_privacidade.pdf";
  link_termos_uso="https://sgsipoliticaprivacidade.blob.core.windows.net/acampapolicy/Termo_de_uso.pdf";

  
  constructor(public platform: Platform, 
    public statusBar: StatusBar, 
    public splashScreen: SplashScreen, 
    private confSrv: ConfiguracaoConcessionariaProvider,
    private menuCtrl: MenuController,
    private androidPermissions: AndroidPermissions,
    private modalCtrl: ModalController,
    private spinnerSrv: SpinnerProvider,    
    private transfer: FileTransfer,
    private file: File,
    private fileOpener: FileOpener,
    private alertSrv: AlertProvider,
    private socketSrv: SocketProvider,
    private cdr: ChangeDetectorRef
   // private pushNotification: PushNotificationProvider
    ) {
    this.initializeApp();
    this.menuCtrl.swipeEnable(false);
    platform.ready().then(() => {

      this.androidPermissions.requestPermissions(
        [
          this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE, 
          this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE,
          this.androidPermissions.PERMISSION.FOREGROUND_SERVICE,
          this.androidPermissions.PERMISSION.RECORD_AUDIO,
          this.androidPermissions.PERMISSION.CAMERA,
        ]
      );

    }) 
    // this.backgroundMode.setDefaults({ silent: true });
    // this.backgroundMode.enable();
    let valor = this.confSrv.isConcessionaria();

    valor.then(async (val) => {
      if(val)
      {
        this.concessionaria = JSON.parse(val);
        
        //inicia a notificacao push
       // const nivelUsuario: string = this.concessionaria.nivel == 0 ? "concessionaria" : (this.concessionaria.nivel == 1 ? "consultor": this.concessionaria.nivel == 2 ? "mecanico" : "outro");
       // this.pushNotification.startNotification(this.concessionaria.codConcessionaria, nivelUsuario);


        let dataValidade = this.concessionaria.validade;
        let datavencer = new Date();
        datavencer.setDate(datavencer.getDate()+5);
        // console.log('datavencer',datavencer);
        // console.log('dataValidade',dataValidade);

        if(Date.parse(dataValidade) < Date.parse(datavencer.toDateString()))
        {
          this.rootPage = 'AtualizarPage';
        }
        else
        {
          if(this.concessionaria.tipoApp == 2 || this.concessionaria.tipoApp == 3)
          {
            this.rootPage = 'ChecklistListagemPage';
          }
          else if(this.concessionaria.appBeta)
          {
            this.rootPage = 'OnlineFamiliaNovoPage';
          }
          else
          {
            this.rootPage = 'OnlineFamiliaPage';
          }

          
        }

        this.pages = new Array<MenuModel>();

        if( this.concessionaria.tipoApp == 1 && (this.concessionaria.nivel == 1 || this.concessionaria.nivel == 0))
        {
          if(this.concessionaria.appBeta)
          {  this.pages.push({ title: 'Home', component: 'OnlineFamiliaNovoPage', icon: 'star-outline', descricao: 'Página inicial' });
          }
          if(this.concessionaria.buscaplaca == 1)
          {
            this.pages.push({ title: 'Agendamentos', component: 'AgendamentoListagemPage', icon: 'notifications-outline', descricao: 'Lista os agendamentos realizados' });
          }
            this.pages.push({ title: 'Cardápios', component: 'OnlineFamiliaPage', icon: 'star-outline', descricao: 'Ofertas por revisão e modelo' });
        }

        if(this.concessionaria.checklist != "")
        {

          let checklists = this.concessionaria.checklist.split(";");
          checklists = checklists.filter(element => element);

          if(checklists && checklists.length > 1){
            this.multiChecklists = true;

            this.checklistsNome = this.concessionaria.checklistNome.split(";");
            this.checklistsNome = this.checklistsNome.filter(element => element);
          } else {
            this.multiChecklists = false;
          }

          
          if(this.concessionaria.tipoApp == 1)
          {
            this.pages.push({ title: 'CheckList em Andamento', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
            this.pages.push({ title: 'CheckList Concluídos', component: 'ChecklistListagemFinalizadosPage', icon: 'cloud-outline', descricao: 'Listagem dos últimos finalizados' });

            this.pages.push({ title: 'Orçamento em Andamento', component: 'OrcamentoListagemPage', icon: 'car', descricao: 'Acompanhe e realize os orçamentos' });

            if( this.concessionaria.checklistCompleto.search("1") != -1 && (this.concessionaria.nivel == 1 || this.concessionaria.nivel == 0))
            {
              this.pages.push({ title: 'Mapa do CheckList', component: 'ChecklistMapaPage', icon: 'notifications-outline', descricao: 'Acompanhamento Por Setor' });
            }
          }
          if(this.concessionaria.tipoApp == 3 ){
            this.pages.push({ title: 'CheckList em Andamento', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
            this.pages.push({ title: 'CheckList Concluídos', component: 'ChecklistListagemFinalizadosPage', icon: 'cloud-outline', descricao: 'Listagem dos últimos finalizados' });
          }
          if(this.concessionaria.tipoApp == 2)
          {
            this.pages.push({ title: 'Administrar CheckList', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
           
          }

        }
        if(this.concessionaria.nivel == 1 && this.concessionaria.temAtualizarAssinatura){
          this.pages.push({ title: 'Atualizar Assinatura', component: 'AtualizarAssinatura', icon: 'md-create', descricao: '' });
        }
        if(this.concessionaria.concessionariasAcesso && this.concessionaria.concessionariasAcesso.length>1){
          this.pages.push({ title: 'Trocar Concessionária', component: 'OnlineModalTrocarConcessionaria', icon: 'git-compare', descricao: '' });
        }
        this.pages.push({ title: 'Atualizar Dados', component: 'AtualizarPage', icon: 'refresh', descricao: '' });
        this.pages.push({ title: 'Sair', component: 'SairPage', icon: 'log-in', descricao: '' });

        await this.confSrv.iniciaImagens();
        await this.iniciaSocket();
      }
      else
      {
        this.rootPage = 'ConfiguracaoConcessionariaPage';
      }
    })


  }

  public iniciaSocket(){
    if(this.concessionaria.recebeNotificacaoApp){
      const codigo = this.concessionaria.nivel == 2 ? this.concessionaria.cod_mecanico : (this.concessionaria.nivel == 1 ? this.concessionaria.cod_consultor : null);
      const rota = this.concessionaria.nivel == 2 ? "_mecanicoApp_" : (this.concessionaria.nivel == 1 ? "_consultorApp_": "_acessoCompletoApp_");
      const topicoGeral = "ACAMPA_"+(this.getDistribuidor()).toLowerCase()+rota+this.concessionaria.codConcessionaria;
      this.socketSrv.disconnect();
      console.log("🚀 ~ MyApp ~ topicoGeral:", topicoGeral)
      this.socketSrv.startSocket(topicoGeral);
      if(codigo){
        const topicoUnico = "ACAMPA_"+(this.getDistribuidor()).toLowerCase()+rota+this.concessionaria.codConcessionaria+"_"+codigo;
        this.socketSrv.startSocket(topicoUnico);
      }
    }
  }

  /**
   * atualizaconcessioanria
   */
  public atualizadadosconcessionaria(_concessionaria: ConcessionariaModel) {

    this.concessionaria = _concessionaria;
    
    if(this.concessionaria && this.concessionaria.nome_marca) {
        if(this.concessionaria.nome_marca.toUpperCase() === 'RENAULT' && this.concessionaria.tipoApp == 1) {
            document.body.classList.add('theme-black');
            this.logoAtual = 'assets/imgs/logoacampa_top_black.png';
        } else {
            document.body.classList.remove('theme-black');
            this.logoAtual = 'assets/imgs/logoacampa_top.png';
        }
    }

    if(this.cdr) this.cdr.detectChanges();


    this.pages = new Array<MenuModel>();

    if(this.concessionaria.codConcessionaria)
    {
      if( this.concessionaria.tipoApp == 1 && ( this.concessionaria.nivel == 1 || this.concessionaria.nivel == 0 ) )
      {
        if(this.concessionaria.appBeta)
        {  this.pages.push({ title: 'Home', component: 'OnlineFamiliaNovoPage', icon: 'star-outline', descricao: 'Página inicial' });
        }
        if(this.concessionaria.buscaplaca == 1)
        {
          this.pages.push({ title: 'Agendamentos', component: 'AgendamentoListagemPage', icon: 'notifications-outline', descricao: 'Lista os agendamentos realizados' });
        }
          this.pages.push({ title: 'Cardápios', component: 'OnlineFamiliaPage', icon: 'star-outline', descricao: 'Ofertas por revisão e modelo' }); 
      }

      if(this.concessionaria.checklist != "")
      {

        let checklists = this.concessionaria.checklist.split(";");
        checklists = checklists.filter(element => element);

        if(checklists && checklists.length > 1){
          this.multiChecklists = true;

          this.checklistsNome = this.concessionaria.checklistNome.split(";");
          this.checklistsNome = this.checklistsNome.filter(element => element);
        } else {
          this.multiChecklists = false;
        }

        
        if(this.concessionaria.tipoApp == 1)
        {
          this.pages.push({ title: 'CheckList em Andamento', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
          this.pages.push({ title: 'CheckList Concluídos', component: 'ChecklistListagemFinalizadosPage', icon: 'cloud-outline', descricao: 'Listagem dos últimos finalizados' });

          this.pages.push({ title: 'Orçamento em Andamento', component: 'OrcamentoListagemPage', icon: 'car', descricao: 'Acompanhe e realize os orçamentos' });
          if( this.concessionaria.checklistCompleto.search("1") != -1 && (this.concessionaria.nivel == 1 || this.concessionaria.nivel == 0))
          {
            this.pages.push({ title: 'Mapa do CheckList', component: 'ChecklistMapaPage', icon: 'notifications-outline', descricao: 'Acompanhamento Por Setor' });
          }
        }
        if(this.concessionaria.tipoApp == 3 ){
          this.pages.push({ title: 'CheckList em Andamento', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
          this.pages.push({ title: 'CheckList Concluídos', component: 'ChecklistListagemFinalizadosPage', icon: 'cloud-outline', descricao: 'Listagem dos últimos finalizados' });
        }

        if(this.concessionaria.tipoApp == 2)
        {
          this.pages.push({ title: 'Administrar CheckList', component: 'ChecklistListagemPage', icon: 'checkmark-circle-outline', descricao: 'Acompanhe e realize as etapas' });
          
        }
      }
      if(this.concessionaria.nivel == 1 &&  this.concessionaria.temAtualizarAssinatura ){
        this.pages.push({ title: 'Atualizar Assinatura', component: 'AtualizarAssinatura', icon: 'md-create', descricao: '' });
      }
      console.log("this.concessionaria ", this.concessionaria);
      if(this.concessionaria.concessionariasAcesso && this.concessionaria.concessionariasAcesso.length>1 ){
        this.pages.push({ title: 'Trocar Concessionária', component: 'OnlineModalTrocarConcessionaria', icon: 'git-compare', descricao: '' });
      }
      this.pages.push({ title: 'Atualizar Dados', component: 'AtualizarPage', icon: 'refresh', descricao: '' });
      this.pages.push({ title: 'Sair', component: 'SairPage', icon: 'log-in', descricao: '' });
    }
  }
  

  async initializeApp() {
    const tema = await this.confSrv.getTheme(); // recupera o tema salvo

    if (tema) {
      document.body.classList.add(tema);

      if (tema === 'theme-black') {
        this.logoAtual = 'assets/imgs/logoacampa_top_black.png';
      } else {
        this.logoAtual = 'assets/imgs/logoacampa_top.png';
      }
    } else {
      this.logoAtual = 'assets/imgs/logoacampa_top.png';
    }

  this.cdr.detectChanges();
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //this.statusBar.styleDefault();

      this.statusBar.styleLightContent();
      this.splashScreen.hide();
      
    });
  }

  getVersion()
  {
    return ConfigHelper.Version;
  }

  getDistribuidor()
  {
    return ConfigHelper.Distribuidor;
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  openModal(modalName, modalDados = null) {
    const modal = this.modalCtrl.create(modalName, modalDados);
    modal.present();

    modal.onDidDismiss(data => {
      if(data){
        let valor = this.confSrv.isConcessionaria();

        valor.then((val) => {
          if(val)
          {
            this.concessionaria = JSON.parse(val);
            this.atualizadadosconcessionaria(this.concessionaria);
            if(this.concessionaria.appBeta)
            {  
              this.nav.setRoot('OnlineFamiliaNovoPage');
            }else{
              this.nav.setRoot('OnlineFamiliaPage');
            }
          }
        });
        console.log('retorno dados do modal ',data);
      }

    });
  }

  getRemove(dd: string) {
    if(dd)
    {
      let newString = dd.replace(/(\d*)-(\d*)-(\d*) (\d*):(\d*).*/, '$3/$2/$1 $4:$5');
      //let newString = dd.replace(/:/g,'').replace(/-/g,'').replace(/ /g,'');
      return newString;
    }
  }

  visualizarPDF(tipo: string) {
    const urlpdf = tipo === 'termos-uso' ? this.link_termos_uso : this.link_politica_privacidade;

    const abrirPDF = (entry: any) => {
      const checkFileExists = (path: string): Promise<boolean> => {
        return new Promise((resolve) => {
          (window as any).resolveLocalFileSystemURL(
            path,
            () => resolve(true),
            () => resolve(false)
          );
        });
      };

      checkFileExists(entry.nativeURL).then((exists) => {
        const fileToOpen = exists ? entry.nativeURL : entry.toURL();

        this.fileOpener.open(fileToOpen, "application/pdf")
          .then(() => this.spinnerSrv.Hide())
          .catch((error) => {
            console.log("entry", entry);
            console.log("error", error);
            this.alertSrv.newAlert(
              "erro",
              "Não foi possível abrir o PDF",
              "",
              "Tente novamente, se o problema persistir informar ao setor de tecnologia"
            );
            this.spinnerSrv.Hide();
          });
      });
    };

    if (this.platform.is('cordova')) {
      const transfer = this.transfer.create();
      const path = this.platform.is('ios') ? this.file.documentsDirectory : this.file.dataDirectory;

      this.spinnerSrv.Show("Fazendo download do PDF...");

      transfer.download(urlpdf, path + tipo + ".pdf")
        .then(abrirPDF)
        .catch((error) => {
          console.log("download error", error);
          this.spinnerSrv.Hide();
          this.alertSrv.newAlert(
            "erro",
            "Sem conexão com o Servidor",
            "",
            "Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!"
          );
        });
    } else {
      window.open(urlpdf, '_blank');
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts